// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__36eOT","footer":"ModalCreateQualiphyProcedure_footer__26tMd","additionData":"ModalCreateQualiphyProcedure_additionData__3tLE_"};